import { SCHEMA_NAME_PATTERN } from '@cli-constants/patterns.js'
import { SCHEMA_NAME_VALIDATION_MESSAGE } from '@cli-constants/prompt-copy.js'

export function validateSchemaName(name: string): string | undefined {
  if (!name.trim()) {
    return 'Enter a schema name.'
  }

  if (!SCHEMA_NAME_PATTERN.test(name)) {
    return SCHEMA_NAME_VALIDATION_MESSAGE
  }

  return undefined
}
